
const removeScript = (googleTracking, pageTracking) => {
  const google = document.getElementById(googleTracking);
  const page = document.getElementById(pageTracking);

  if (google) google.remove();
  if (page) page.remove();
};
export default removeScript;



/** WEBPACK FOOTER **
 ** ./src/tagManagerRemove.js
 **/